var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillOpacity: 0.01,
    d: "M0 0h20v20H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 16.667l1.25 1.666L10 20l1.25-1.667 1.25-1.666h3.333A4.167 4.167 0 0020 12.5V5.833a4.167 4.167 0 00-4.167-4.166H4.167A4.167 4.167 0 000 5.833V12.5a4.167 4.167 0 004.167 4.167H7.5zm2.5 0l.9-1.2.6-.8h4.333c1.197 0 2.167-.97 2.167-2.167V5.833c0-1.196-.97-2.166-2.167-2.166H4.167C2.97 3.667 2 4.637 2 5.833V12.5c0 1.197.97 2.167 2.167 2.167H8.5l.6.8.9 1.2z"
  })));
}
export default SvgComment;